import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './AutocompleteResult.module.scss'

const propTypes = {
  focused: PropTypes.bool,
  className: PropTypes.string
}

const AddressResult = ({ className, focused, ...restProps }) => (
  <li
    role='option'
    aria-selected={focused}
    className={classnames(styles.root, focused && styles.focused, className)}
    {...restProps}
  />
)

AddressResult.propTypes = propTypes

export default AddressResult
